var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabConsigneeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.634,
    height: 17.275,
    viewBox: "0 0 12.634 17.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12525",
    "data-name": "Group 12525",
    transform: "translate(1178.792 -355.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12523",
    "data-name": "Group 12523",
    transform: "translate(-2478 -417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39712",
    "data-name": "Path 39712",
    d: "M1310.047,788.115h-9.122",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39713",
    "data-name": "Path 39713",
    d: "M1300.2,786.677v-1.823h10.63v1.823",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_614",
    "data-name": "Line 614",
    y2: 2.12,
    transform: "translate(1301.258 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_616",
    "data-name": "Line 616",
    y2: 2.12,
    transform: "translate(1304.666 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_617",
    "data-name": "Line 617",
    y2: 2.12,
    transform: "translate(1306.37 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_618",
    "data-name": "Line 618",
    y2: 2.12,
    transform: "translate(1308.074 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_619",
    "data-name": "Line 619",
    y2: 2.12,
    transform: "translate(1309.778 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12514",
    "data-name": "Group 12514"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_615",
    "data-name": "Line 615",
    y2: 2.12,
    transform: "translate(1302.962 785.422)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39714",
    "data-name": "Path 39714",
    d: "M1302.628,775.878a2.909,2.909,0,1,0,2.91-2.91A2.91,2.91,0,0,0,1302.628,775.878Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39715",
    "data-name": "Path 39715",
    d: "M1305.538,789.588h-6v-7.205a1.4,1.4,0,0,1,.71-1.219l3.17-1.8,2.044,3.25",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39716",
    "data-name": "Path 39716",
    d: "M1305.459,784.854v-2.239l2.176-3.251,3.169,1.8a1.4,1.4,0,0,1,.71,1.22v7.205h-6v-1.473",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39717",
    "data-name": "Path 39717",
    d: "M1299.535,786.495a1.363,1.363,0,0,1,0,2.726",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39718",
    "data-name": "Path 39718",
    d: "M1311.515,789.221a1.363,1.363,0,1,1,0-2.726",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabConsigneeIcon);
export default __webpack_public_path__ + "static/media/tab-consignee-icon.3e5ffc29e324f75a92930a7a62fdc8a3.svg";
export { ForwardRef as ReactComponent };